var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { getFetchWrapper } from "@syf-api-library/core";
import { paymentMethodsUrl } from "../endpoints.js";
const deletionFnFactory = (config, keyProps) => {
  const fetchWrapper = getFetchWrapper(config);
  return (payload) => {
    const { id: paymentMethodIdToDelete } = payload;
    const { accountId, accountIdType } = keyProps;
    const deletePaymentMethodUrl = `${paymentMethodsUrl}/${paymentMethodIdToDelete}`;
    const queryParams = new URLSearchParams(__spreadValues({
      "cipher.accountId": accountId
    }, accountIdType && { accountIdType }));
    return fetchWrapper(`${deletePaymentMethodUrl}?${queryParams}`, {
      method: "DELETE"
    });
  };
};
export {
  deletionFnFactory as default
};
//# sourceMappingURL=deletion.js.map
